import { render, staticRenderFns } from "./View.vue?vue&type=template&id=dc0a2c66&scoped=true"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
import style0 from "@/styles/inner/view.scss?vue&type=style&index=0&prod&lang=scss&external"
import style1 from "./styles/index.css?vue&type=style&index=1&id=dc0a2c66&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc0a2c66",
  null
  
)

export default component.exports